export const FETCH_USER_BY_ID = 'FETCH_USER_BY_ID';
export const FETCH_USER_BY_ID_START = `${FETCH_USER_BY_ID}_START`;
export const FETCH_USER_BY_ID_SUCCESS = `${FETCH_USER_BY_ID}_SUCCESS`;
export const FETCH_USER_BY_ID_ERROR = `${FETCH_USER_BY_ID}_ERROR`;
export const FETCH_ALL_USERS = 'FETCH_ALL_USERS';
export const FETCH_ALL_USERS_START = `${FETCH_ALL_USERS}_START`;
export const FETCH_ALL_USERS_SUCCESS = `${FETCH_ALL_USERS}_SUCCESS`;
export const FETCH_ALL_USERS_ERROR = `${FETCH_ALL_USERS}_ERROR`;
export const NEW_ACTIVE_USER = 'NEW_ACTIVE_USER';
export const NEW_USER_ACTIVITY = 'NEW_USER_ACTIVITY';
export const REMOVE_USER_ACTIVITY = 'REMOVE_USER_ACTIVITY';
export const USER_LEFT = 'USER_LEFT';
export const RESET_ACTIVE_USERS = 'RESET_ACTIVE_USERS';
//# sourceMappingURL=actionTypes.js.map